import React from 'react';
import classnames from 'classnames';
import * as styles from './burgerBtn.module.scss';

const BurgerBtn = (props) => {
  return (
    <button
      type="button"
      className={classnames(styles.burger, props.className)}
    ></button>
  );
};

export default BurgerBtn;
